const uz = {
  // Common
  "common.loading": "Yuklanmoqda...",
  "common.error": "Xato yuz berdi",
  "common.save": "Saqlash",
  "common.cancel": "Bekor qilish",
  "common.delete": "O'chirish",
  "common.edit": "Tahrirlash",
  "common.back": "Orqaga",
  "common.logout": "Chiqish",
  "common.submit": "Yuborish",
  "common.search": "Qidirish",
  "common.noData": "Ma'lumot topilmadi",
  "common.retry": "Qayta urinish",
  "common.close": "Yopish",
  "common.more": "Ko'proq",
  "common.open_app": "Ilovani ochish",

  // Auth
  "auth.login": "Kirish",
  "auth.register": "Ro'yxatdan o'tish",
  "auth.logout": "Chiqish",
  "auth.email": "Email",
  "auth.password": "Parol",
  "auth.confirm_password": "Parolni tasdiqlash",
  "auth.username": "Foydalanuvchi nomi",
  "auth.display_name": "To'liq ism",
  "auth.forgot_password": "Parolni unutdingizmi?",
  "auth.no_account": "Akkauntingiz yo'qmi?",
  "auth.has_account": "Akkauntingiz bormi?",
  "auth.google_login": "Google orqali kirish",
  "auth.login_success": "Tizimga muvaffaqiyatli kirildі",
  "auth.register_success": "Ro'yxatdan muvaffaqiyatli o'tildi",
  "auth.logout_success": "Tizimdan chiqildi",
  "auth.verify_email": "Email tasdiqlash",
  "auth.otp_sent": "Tasdiqlash kodi emailingizga yuborildi",
  "auth.enter_otp": "6 xonali kodni kiriting",
  "auth.resend_otp": "Kodni qayta yuborish",
  "auth.otp_verified": "Email tasdiqlandi!",

  // Navigation
  "nav.feed": "Lenta",
  "nav.lifemap": "Hayotim",
  "nav.ai": "AI",
  "nav.calendar": "Taqvim",
  "nav.new_post": "Yangi",
  "nav.video": "Video kundalik",
  "nav.challenges": "Musobaqalar",
  "nav.highlights": "Ajratilganlar",
  "nav.journal": "Kundalik",
  "nav.analytics": "Tahlil",
  "nav.search": "Qidirish",
  "nav.notifications": "Bildirishnomalar",
  "nav.settings": "Sozlamalar",
  "nav.galaxy": "Hayot Yulduzlari",
  "nav.profile": "Profil",
  "nav.other": "Boshqa",

  // Feed
  "feed.title": "Lenta",
  "feed.no_posts": "Hali postlar yo'q",
  "feed.load_more": "Ko'proq yuklash",
  "feed.create_first": "Birinchi postingizni yozing",

  // Post
  "post.create": "Post yaratish",
  "post.title": "Sarlavha (ixtiyoriy)",
  "post.body": "Bugun nima bo'ldi? Fikrlaringizni yozing...",
  "post.date": "Sana",
  "post.mood": "Kayfiyat",
  "post.privacy": "Kimlar ko'radi",
  "post.tags": "Teglar",
  "post.location": "Joylashuv",
  "post.media": "Rasm/Video qo'shish",
  "post.add_tag": "Teg qo'shish",
  "post.save": "Saqlash",
  "post.delete": "Postni o'chirish",
  "post.delete_confirm": "Postni o'chirishni tasdiqlaysizmi?",
  "post.saved": "Post saqlandi! ✨",
  "post.deleted": "Post o'chirildi",
  "post.view_day": "Kun ko'rish",
  "post.comments": "Izohlar",
  "post.no_comments": "Hali izoh yo'q. Birinchi bo'ling! 💬",
  "post.add_comment": "Izoh yozing...",
  "post.comment_added": "Izoh qo'shildi",
  "post.reaction_failed": "Reaksiya bajarilmadi",

  // Privacy options
  "privacy.public": "Hamma",
  "privacy.friends": "Do'stlar",
  "privacy.private": "Faqat men",

  // Mood options
  "mood.great": "Ajoyib",
  "mood.good": "Yaxshi",
  "mood.neutral": "O'rtacha",
  "mood.bad": "Yomon",
  "mood.terrible": "Juda yomon",

  // Calendar
  "calendar.title": "Hayot taqvimi",
  "calendar.year": "Yil",
  "calendar.today": "Bugun",
  "calendar.this_day": "Shu kun esdaliklari",
  "calendar.no_entries": "Bu kunda yozuvlar yo'q",
  "calendar.view_day": "Kunni ko'rish",
  "calendar.days_active": "Faol kunlar",
  "calendar.total_posts": "Jami postlar",

  // Analytics
  "analytics.title": "Hayot tahlili",
  "analytics.period.week": "Hafta",
  "analytics.period.month": "Oy",
  "analytics.period.year": "Yil",
  "analytics.mood_trends": "Kayfiyat o'zgarishi",
  "analytics.activity": "Faollik",
  "analytics.growth": "O'sish",

  // Profile
  "profile.title": "Profil",
  "profile.edit": "Profilni tahrirlash",
  "profile.posts": "Postlar",
  "profile.friends": "Do'stlar",
  "profile.add_friend": "Do'st qo'shish",
  "profile.request_sent": "So'rov yuborildi",
  "profile.bio": "Bio",
  "profile.location": "Joylashuv",
  "profile.website": "Veb-sayt",
  "profile.joined": "Qo'shilgan",

  // Settings
  "settings.title": "Sozlamalar",
  "settings.profile": "Profil",
  "settings.security": "Xavfsizlik",
  "settings.notifications": "Bildirishnomalar",
  "settings.language": "Til",
  "settings.language.select": "Tilni tanlang",
  "settings.language.uz": "O'zbek",
  "settings.language.ru": "Rus",
  "settings.language.en": "Ingliz",
  "settings.save_profile": "Profilni saqlash",
  "settings.change_password": "Parolni o'zgartirish",
  "settings.current_password": "Hozirgi parol",
  "settings.new_password": "Yangi parol",
  "settings.delete_account": "Akkauntni o'chirish",
  "settings.profile_saved": "Profil saqlandi",
  "settings.password_changed": "Parol o'zgartirildi",

  // Search
  "search.title": "Qidirish",
  "search.placeholder": "Foydalanuvchi qidirish...",
  "search.no_results": "Natija topilmadi",

  // Notifications
  "notifications.title": "Bildirishnomalar",
  "notifications.empty": "Bildirishnomalar yo'q",
  "notifications.mark_all_read": "Barchasini o'qilgan deb belgilash",

  // Video
  "video.title": "Video kundalik",
  "video.upload": "Video yuklash",
  "video.no_videos": "Hali videolar yo'q",
  "video.uploading": "Yuklanmoqda...",

  // Challenges
  "challenges.title": "Musobaqalar",
  "challenges.join": "Ishtirok etish",
  "challenges.active": "Faol",
  "challenges.completed": "Bajarilgan",

  // Highlights
  "highlights.title": "Ajratilganlar",
  "highlights.create": "Ajratilgan yaratish",
  "highlights.empty": "Hali ajratilganlar yo'q",

  // Journal
  "journal.title": "Kundalik",
  "journal.new_entry": "Yangi yozuv",
  "journal.no_entries": "Hali yozuvlar yo'q",

  // Errors
  "error.network": "Tarmoq xatosi. Internetni tekshiring.",
  "error.unauthorized": "Tizimga kirishingiz talab etiladi",
  "error.not_found": "Sahifa topilmadi",
  "error.server": "Server xatosi. Keyinroq urinib ko'ring.",
  "error.login_failed": "Login yoki parol noto'g'ri",
  "error.register_failed": "Ro'yxatdan o'tishda xato",

  // Days of week
  "day.mon": "Du",
  "day.tue": "Se",
  "day.wed": "Ch",
  "day.thu": "Pa",
  "day.fri": "Ju",
  "day.sat": "Sh",
  "day.sun": "Ya",

  // Months
  "month.1": "Yanvar",
  "month.2": "Fevral",
  "month.3": "Mart",
  "month.4": "Aprel",
  "month.5": "May",
  "month.6": "Iyun",
  "month.7": "Iyul",
  "month.8": "Avgust",
  "month.9": "Sentabr",
  "month.10": "Oktabr",
  "month.11": "Noyabr",
  "month.12": "Dekabr",
};

export default uz;
